import type { App } from 'vue'
import api from './api'

export default {
	install(app: App) {
		app.config.globalProperties.$api = api
	}
}
